<button [type]="type" class="btn" [ngClass]="cssClass" [disabled]="!canClick" (click)="onClick($event)">
    <div *ngIf="!loading">
        <ng-container *ngIf="icon">
            <app-icon [symbol]="icon"></app-icon>
        </ng-container>
        <span class="btn__label">
            <ng-content></ng-content>
        </span>
        <ng-container *ngIf="iconRight">
            <app-icon [symbol]="iconRight" class="icon-right"></app-icon>
        </ng-container>
    </div>

    <div *ngIf="loading" class="loader">
        <app-icon symbol="Spinner-small"></app-icon>
    </div>
</button>
